import axios from 'axios';
import { deleteAllCookies, getCookie } from './Utils';

const ApiCall = axios.create({
    baseURL: 'https://bizcarto.in/customer/api',
    // baseURL: 'http://localhost/customer_order_app',
    timeout: 20000,
    headers: { 'Content-Type': 'application/json' }
});
ApiCall.interceptors.request.use(
    (config) => {
        const token = getCookie('sessionToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

ApiCall.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
            deleteAllCookies()
        }
        return Promise.reject(error);
    }
);

export default ApiCall;